module.exports = __webpack_public_path__ + "images/riyuMap.png?v=ed9af0c3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/list/riyuMap.png
 ** module id = 242
 ** module chunks = 3
 **/